export default __webpack_public_path__ + "static/media/user-thumb.69995036.png";